/* Small, dependency-free drawer; navigation is rendered by Shopify. */
(() => {
  'use strict';
  const instances = new Map();
  const init = (scope = document) => scope.querySelectorAll('[data-header-drawer]').forEach((root) => {
    if (instances.has(root)) return;
    const header = root.closest('.rh-header-section') || root;
    const updateHeaderHeight = () => document.documentElement.style.setProperty('--rh-header-height', Math.ceil(header.getBoundingClientRect().height) + 'px');
    updateHeaderHeight();
    const headerResize = 'ResizeObserver' in window ? new ResizeObserver(updateHeaderHeight) : null;
    headerResize?.observe(header);
    if (!headerResize) window.addEventListener('resize', updateHeaderHeight, { passive: true });
    const trigger = root.querySelector('[data-menu-trigger]');
    const drawer = root.querySelector('[data-menu-drawer]');
    if (!trigger || !drawer || typeof drawer.showModal !== 'function') {
      instances.set(root, () => {
        headerResize?.disconnect();
        window.removeEventListener('resize', updateHeaderHeight);
        instances.delete(root);
      });
      return;
    }
    const events = new AbortController();
    const on = (element, type, handler) => element.addEventListener(type, handler, { signal: events.signal });
    let restoreFocus = null;
    let backdropStart = false;
    const outside = (event) => {
      const box = drawer.getBoundingClientRect();
      return event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom;
    };
    const syncClosed = () => {
      trigger.setAttribute('aria-expanded', 'false');
      if (!document.querySelector('[data-menu-drawer][open]')) document.documentElement.classList.remove('rh-menu-open');
      if (restoreFocus?.isConnected) restoreFocus.focus({ preventScroll: true });
      restoreFocus = null;
    };
    const close = () => { if (drawer.open) drawer.close(); };
    on(trigger, 'click', () => {
      if (drawer.open) { close(); return; }
      restoreFocus = trigger;
      drawer.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('rh-menu-open');
      drawer.querySelector('[data-menu-close]')?.focus({ preventScroll: true });
    });
    on(drawer, 'close', syncClosed);
    on(drawer, 'cancel', (event) => { event.preventDefault(); close(); });
    on(drawer, 'pointerdown', (event) => { backdropStart = event.target === drawer && outside(event); });
    on(drawer, 'click', (event) => {
      if (event.target.closest('[data-menu-close]') || event.target.closest('a[href]')) close();
      else if (event.target === drawer && backdropStart && outside(event)) close();
      backdropStart = false;
    });
    on(drawer, 'keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),summary,input:not([disabled]),[tabindex="0"]')).filter((element) => element.getClientRects().length);
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (!first) { event.preventDefault(); return; }
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    instances.set(root, () => {
      restoreFocus = null;
      close();
      events.abort();
      headerResize?.disconnect();
      window.removeEventListener('resize', updateHeaderHeight);
      syncClosed();
      instances.delete(root);
    });
  });
  init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => instances.forEach((destroy, root) => { if (event.target.contains(root)) destroy(); }));
})();
